<style lang="scss" scoped>
.asset-page {
    padding: 16px;
    background: #fff;
    min-height: 400px;

    /* 窄屏适配 */
    @media (max-width: 600px) {
        padding: 10px;
    }
}
</style>

<style lang="scss">
/* append-to-body 弹窗脱离组件作用域：宽度由 c-el-dialog(96%) 自适应，修饰类单独封顶；弹窗内样式须全局定义（asset- 前缀防污染） */
.asset-dialog {
    .el-dialog__body {
        overflow-wrap: anywhere;
    }

    /* 功能说明弹窗段落 */
    .asset-help p {
        margin: 0 0 10px;
        line-height: 1.7;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .el-date-editor,
    .el-select {
        max-width: 100%;
    }
}

.asset-dialog--form { max-width: 580px; }
.asset-dialog--help { max-width: 620px; }
</style>

<template>
    <div class="asset-page">
        <!-- 工具栏：左侧主操作（新增/导入/变更日志/功能说明），右侧筛选/查询/重置/导出（对齐项目 toolbars 布局） -->
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <!-- 中控↔车架绑定：仅中控页提供，先查出该车架的占用者（待解绑），再按中控建档/改档表单一次完成绑定 -->
                    <!-- <el-button v-if="kind === 'control' && canManage" class="mrgr5 mrgb5" type="success" size="medium" @click="$refs.bindingDialog.open()"><i class="fa fa-link"></i> 绑定</el-button> -->
                    <!-- 中控编辑：统一中控的新增/修改/换绑（替代「新增中控」与行内编辑），输入中控号自动加载 -->
                    <el-button v-if="kind === 'control' && canManage" class="mrgr5 mrgb5" type="primary" size="medium" @click="$refs.controlEdit.open()"><i class="fa fa-edit"></i> 中控编辑</el-button>
                    <el-button v-if="kind !== 'control' && canManage" class="mrgr5 mrgb5" type="primary" size="medium" @click="edit()"><i class="fa fa-plus"></i> 新增{{ config.title }}</el-button>
                    <import-button v-if="primaryImport && canManage" class="mrgr5 mrgb5" :label="primaryImport.label" :handler="primaryImport.handler" @complete="search"></import-button>
                    <import-button v-if="kind === 'policy' && canManage" class="mrgr5 mrgb5" label="导入保单" :handler="policyApi.import" @complete="search"></import-button>
                    <el-button v-if="canLogs" class="mrgr5 mrgb5" size="medium" @click="$refs.logs.open(configEntityType, '')"><i class="fa fa-file-text-o"></i> 变更日志</el-button>
                    <el-button class="mrgr5 mrgb5" size="medium" @click="helping = true"><i class="fa fa-question-circle-o"></i> 功能说明</el-button>
                </div>
                <div class="fr">
                    <el-input class="c-el-input mrgr5 mrgb5" size="medium" clearable v-model.trim="query.keywords" :placeholder="config.placeholder" @clear="search"></el-input>
                    <el-button class="mrgb5" type="primary" size="medium" @click="search()"><i class="fa fa-search"></i> 查询</el-button>
                    <el-button class="mrgb5" size="medium" @click="reset"><i class="fa fa-undo"></i> 重置</el-button>
                    <el-button v-if="canExport" class="mrgb5" type="warning" size="medium" :loading="exporting" @click="exportData"><i class="fa fa-sign-out"></i> 导出全部{{ config.title }}</el-button>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <div>
            <el-table v-loading="loading" :data="rows" style="width: 100%" border size="medium" row-key="id">
                <el-table-column v-for="field in config.fields" :key="field.key" :label="field.label" :prop="field.key" :min-width="field.width || 150" show-overflow-tooltip>
                    <template slot-scope="scope">{{ field.date ? date(scope.row[field.key]) : scope.row[field.key] || '-' }}</template>
                </el-table-column>
                <el-table-column v-if="kind === 'policy'" label="绑定车辆数" prop="boundVehicleCount" width="105" />
                <el-table-column label="操作" width="100" :fixed="assetMobile ? false : 'right'">
                    <template slot-scope="scope">
                        <!-- 行内操作统一收纳进"更多"下拉（对齐项目操作列惯例） -->
                        <el-dropdown trigger="click">
                            <el-button type="primary" plain size="mini">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-if="kind !== 'control' && canReadBindings" @click.native="showBindings(scope.row)">{{ kind === 'policy' ? '保单详情' : '保险绑定' }}</el-dropdown-item>
                                <el-dropdown-item v-if="canManage" @click.native="edit(scope.row)">编辑</el-dropdown-item>
                                <el-dropdown-item v-if="canManage" @click.native="remove(scope.row)">删除</el-dropdown-item>
                                <el-dropdown-item v-if="canLogs" @click.native="$refs.logs.open(configEntityType, scope.row[config.key])">变更日志</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination background :current-page.sync="query.page" :page-size.sync="query.size" :page-sizes="appPageSizes" layout="total, sizes, prev, pager, next, jumper" :total="total" @current-change="load" @size-change="search"></el-pagination>
            </div>
        </div>
        <el-dialog :title="(form.id ? '编辑' : '新增') + config.title" :visible.sync="editing" custom-class="c-el-dialog asset-dialog asset-dialog--form" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small" @submit.native.prevent="save">
                <el-form-item v-for="field in config.fields" :key="field.key" :label="field.label" :prop="field.key">
                    <el-date-picker v-if="field.date" v-model="form[field.key]" type="date" value-format="yyyy-MM-dd" clearable />
                    <el-input v-else v-model.trim="form[field.key]" :disabled="!!form.id && field.key === config.key" :maxlength="field.max" :type="field.key === 'remark' ? 'textarea' : 'text'" :rows="3" show-word-limit />
                </el-form-item>
            </el-form>
            <span slot="footer"><el-button :disabled="saving" @click="editing = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
        </el-dialog>
        <binding-manager ref="bindings" @changed="load" />
        <control-binding-dialog ref="bindingDialog" @done="load" />
        <control-edit-dialog ref="controlEdit" @done="load" />
        <change-logs ref="logs" />
        <el-dialog :title="`${config.title}页功能说明`" :visible.sync="helping" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--help">
            <div class="asset-help"><p v-for="(line, index) in config.help" :key="index">{{ line }}</p></div>
            <span slot="footer"><el-button type="primary" @click="helping = false">知道了</el-button></span>
        </el-dialog>
    </div>
</template>

<script>
    // 中控 / 车架 / 保单三页共用的台账 CRUD 组件
    import saveAs from 'file-saver'
    import { controlApi, chassisApi, policyApi, assetPermission } from '@/api/vehicleData'
    import permission from '@/mixins/permission'
    import enumConfigs from '@/mixins/enumConfigs'
    import ImportButton from './ImportButton'
    import BindingManager from './BindingManager'
    import ChangeLogs from './ChangeLogs'
    import ControlBindingDialog from './ControlBindingDialog'
    import ControlEditDialog from './ControlEditDialog'
    import assetResponsive from './assetResponsive'

    const configs = {
        control: {
            title: '中控', key: 'controlNo', entityType: 'Control', permission: 'VehicleControlManage', api: controlApi, placeholder: '中控号 / SN / 车架号 / 型号',
            help: [
                '用途：维护中控档案台账（中控号、SN、型号、设备到期日期及其绑定的车架号）。',
                '中控编辑：新增 / 修改 / 换绑三合一（替代「新增中控」与行内编辑）。输入中控号（回车或离开输入框）自动加载现有档案，改任意字段右侧实时显示变更影响与目标车架待解绑清单，点「确认执行」直接生效；中控号、车架号旁的 ◎ 可直接打开「追踪」查全链路日志。',
                '绑定：输入中控号与车架号查询，列出正占用该车架的其它中控（待解绑清单），下方按中控档案表单建立新绑定：车架无档案时自动补建，占用者自动解绑，缺的字段可直接补齐，提交前列出全部变更供确认。',
                '导入 / 导出：均为中控档案本身，导出的 JSON 可直接回导。导入按设备号逐行更新：文件里没写的列保留原值，写了的列（含留空）按文件值覆盖；同一设备号在文件中只能出现一行，重复将整批拒绝。',
                '变更日志：手动编辑与导入的改动均按批次记录，可按批次号查询。'
            ],
            fields: [{ key: 'controlNo', label: '中控号', max: 32 }, { key: 'controlSN', label: '中控 SN', max: 32 }, { key: 'model', label: '型号', max: 50 }, { key: 'chassisNo', label: '车架号', max: 32 }, { key: 'deviceExpiryDate', label: '设备到期日期', date: true, width: 115 }]
        },
        chassis: {
            title: '车架', key: 'chassisNo', entityType: 'Chassis', permission: 'VehicleChassisManage', api: chassisApi, placeholder: '车架号 / 电机号 / 型号',
            help: [
                '用途：维护车架档案台账（车架号、电机号、型号）。',
                '车架保险：切到“车架保险”页签维护全部车架与保单的绑定关系（新增、编辑、结束、删除、导入、导出），该页签不要求车架档案存在。',
                '导出全部车架：仅导出车架档案（JSON），可直接回导。导入按车架号逐行更新：文件里没写的列保留原值，写了的列（含留空）按文件值覆盖；同一车架号在文件中只能出现一行，重复将整批拒绝。'
            ],
            fields: [{ key: 'chassisNo', label: '车架号', max: 32 }, { key: 'motorNo', label: '电机号', max: 32 }, { key: 'model', label: '型号', max: 50 }]
        },
        policy: {
            title: '保单', key: 'policyNumber', entityType: 'Policy', permission: 'VehiclePolicyManage', api: policyApi, placeholder: '保单号 / 类型 / 保险公司 / 投保人 / 被保险人',
            help: [
                '用途：维护保单档案台账（保单号、类型、保险公司、投保人、被保险人、保障期间）。',
                '保单详情：查看该保单绑定的车架并可维护绑定；"绑定车辆数"为当前有效绑定的车架数量；全部绑定也可在车架数据页的“车架保险”页签统一管理。',
                '导入 / 导出：均为保单档案本身，导出可直接回导；导入模板不含车架号，绑定关系请在车架数据页的“车架保险”页签导入或维护。',
                '变更日志：手动编辑与导入的改动均按批次记录，可按批次号查询。'
            ],
            fields: [{ key: 'policyNumber', label: '保单号', max: 100, width: 210 }, { key: 'policyType', label: '保单类型', max: 100, width: 190 }, { key: 'company', label: '保险公司', max: 100, width: 170 }, { key: 'policyHolder', label: '投保人', max: 200, width: 180 }, { key: 'insuredName', label: '被保险人', max: 100, width: 180 }, { key: 'startDate', label: '开始日期', date: true, width: 115 }, { key: 'endDate', label: '结束日期', date: true, width: 115 }, { key: 'remark', label: '备注', max: 2000 }]
        }
    }

    const primaryImports = {
        control: { label: '导入中控', handler: controlApi.import },
        chassis: { label: '导入车架', handler: chassisApi.import }
    }

    export default {
        components: { ImportButton, BindingManager, ChangeLogs, ControlBindingDialog, ControlEditDialog },
        mixins: [permission, assetResponsive, enumConfigs],
        props: { kind: { type: String, required: true, validator: value => !!configs[value] } },
        data: () => ({ controlApi, policyApi, query: { page: 1, size: window.$common.appPageSize, keywords: '' }, rows: [], total: 0, loading: false, editing: false, saving: false, exporting: false, helping: false, form: {}, requestNumber: 0 }),
        computed: {
            config() { return configs[this.kind] },
            // 变更日志对象类型：按台账类型取枚举值（不写死数字）
            configEntityType() {
                const map = {
                    Control: this.valVehicleDataChangeEntityTypeControl,
                    Chassis: this.valVehicleDataChangeEntityTypeChassis,
                    Policy: this.valVehicleDataChangeEntityTypePolicy
                }
                const method = map[this.config.entityType]
                return method ? method() : null
            },
            primaryImport() { return primaryImports[this.kind] || null },
            canManage() { return this.hasSpecialRole(assetPermission(this.config.permission)) },
            canExport() { return this.hasSpecialRole(assetPermission('VehicleInsuranceExport')) },
            canLogs() { return this.hasSpecialRole(assetPermission('VehicleDataChangeLog')) },
            canReadBindings() { return this.hasSpecialRole(assetPermission('VehiclePolicyManage')) || this.hasSpecialRole(assetPermission('VehicleChassisManage')) },
            rules() {
                const rules = { [this.config.key]: [{ required: true, message: `请输入${this.config.fields[0].label}`, trigger: 'blur' }] }
                if (this.kind === 'policy') rules.startDate = [{ required: true, message: '请选择开始日期', trigger: 'change' }]
                return rules
            }
        },
        mounted() { this.load() },
        methods: {
            date(value) { return value ? String(value).slice(0, 10) : '-' },
            search() { this.query.page = 1; this.load() },
            reset() { this.query = { page: 1, size: window.$common.appPageSize, keywords: '' }; this.load() },
            async load() {
                const requestNumber = ++this.requestNumber
                this.loading = true
                try {
                    const result = await this.config.api.list(this.query)
                    if (requestNumber !== this.requestNumber) return
                    this.rows = result.items || []
                    this.total = Number(result.totalCount || 0)
                    if (!this.rows.length && this.query.page > 1 && this.total) { this.query.page--; return this.load() }
                } catch (_) {
                    if (requestNumber === this.requestNumber) { this.rows = []; this.total = 0 }
                } finally { if (requestNumber === this.requestNumber) this.loading = false }
            },
            edit(row) {
                // 中控的新增/编辑统一走「中控编辑」弹框（新增、修改、换绑一体），其余台账保持原表单
                if (this.kind === 'control') {
                    this.$refs.controlEdit.open(row ? row.controlNo : '')
                    return
                }
                const form = { id: row && row.id }
                this.config.fields.forEach(field => { form[field.key] = row ? (field.date ? (row[field.key] ? this.date(row[field.key]) : null) : row[field.key] || '') : field.date ? null : '' })
                this.form = form
                this.editing = true
                this.$nextTick(() => this.$refs.form.clearValidate())
            },
            async save() {
                if (this.saving) return
                const valid = await this.$refs.form.validate().catch(() => false)
                if (!valid) return
                if (this.form.startDate && this.form.endDate && this.form.endDate < this.form.startDate) return this.$message.error('结束日期不能早于开始日期')
                this.saving = true
                try {
                    const input = {}
                    this.config.fields.forEach(field => { input[field.key] = this.form[field.key] || (field.date ? null : '') })
                    if (this.form.id) await this.config.api.update(this.form.id, input)
                    else await this.config.api.create(input)
                    this.editing = false
                    this.$message.success('保存成功')
                    this.load()
                } catch (_) { /* 请求层展示错误，保留表单便于修正。 */ } finally { this.saving = false }
            },
            async remove(row) {
                try {
                    await this.$confirm(`确认删除${this.config.title} ${row[this.config.key]}？`, `删除${this.config.title}`, { type: 'warning' })
                    await this.config.api.remove(row.id)
                    this.$message.success('删除成功')
                    this.load()
                } catch (_) { /* 用户取消或服务器拒绝删除时保留当前页。 */ }
            },
            showBindings(row) {
                this.$refs.bindings.open(this.kind === 'policy' ? { policyNumber: row.policyNumber } : { chassisNo: row.chassisNo }, this.kind === 'policy' ? row : null)
            },
            async exportData() {
                this.exporting = true
                try { saveAs(await this.config.api.export(), `${this.config.title}数据.json`) } catch (_) { /* 请求层展示错误。 */ } finally { this.exporting = false }
            }
        }
    }
</script>
